import React from 'react';

const Button = ({
  children,
  variant = 'primary',
  size = 'md',
  disabled = false,
  loading = false,
  fullWidth = false,
  onClick,
  type = 'button',
  className = '',
  ...props
}) => {
  let buttonClass = 'btn';
  
  // Add variant classes
  if (variant === 'primary') buttonClass += ' btn-primary';
  else if (variant === 'secondary') buttonClass += ' btn-secondary';
  else if (variant === 'outline') buttonClass += ' btn-outline';
  else if (variant === 'success') buttonClass += ' btn-success';
  
  // Add size classes
  if (size === 'sm') buttonClass += ' btn-sm';
  else if (size === 'lg') buttonClass += ' btn-lg';
  
  // Add modifier classes
  if (fullWidth) buttonClass += ' btn-full';
  if (loading) buttonClass += ' btn-loading';
  if (className) buttonClass += ' ' + className;

  return (
    <button
      type={type}
      className={buttonClass}
      disabled={disabled || loading}
      onClick={onClick}
      {...props}
    >
      {loading && <span className="spinner"></span>}
      {children}
    </button>
  );
};

export default Button;